import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { IBadgeComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { ProfitCategory, ProfitLine } from "@m19-board/services/profit-details.service";

@Component({
  selector: "app-profit-details-line",
  template: `
    <ng-container #profitLineTemplate *transloco="let t">
      @if (profitLine().value) {
        <div class="flex justify-between">
          <span class="text-gray-800">{{ t(profitLine().title) }}</span>
          <div class="flex items-center gap-x-2">
            <span class="font-medium text-gray-800">&nbsp;{{ profitLine().formattedValue }}</span>
            <div class="w-12">
              @if (profitLine().formattedShare) {
                <IBadge
                  class="inline-flex"
                  [label]="profitLine().formattedShare"
                  [color]="profitLine().share !== undefined && profitLine().share! >= 0 ? 'green' : 'red'"
                  variant="soft"
                  size="xs"
                />
              }
            </div>
          </div>
        </div>
      }
    </ng-container>
  `,
  imports: [IBadgeComponent, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfitDetailsLineComponent {
  public readonly profitLine = input.required<ProfitLine | ProfitCategory>();
}
